var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 330",
    width: 512,
    height: 330,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "love-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { opacity: .9;fill: #fedb2c } \r\n\t\t.s1 { opacity: 1;fill: #ee687d } \r\n\t\t.s2 { fill: #e63a52 } \r\n\t\t.s3 { opacity: 1;fill: #f7eca9 } \r\n\t\t.s4 { fill: #fecb0d } \r\n\t\t.s5 { fill: #fecb0c } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m240.5 7.5q46.5-2.1 91 11.5 11.8 3.8 20.5 12.5 11.8 16.7-3.5 30.5-17 11-37 15-56 11-112 0-20-4-37-15-17.2-16.1-1-33 12.1-9.3 27-13 25.8-6.7 52-8.5zm-47 24.5q-13.6 3-23 13 4.7 6.1 12 9 25.1 9.5 52 11 45.4 3.9 89-9 10.4-2.9 17-11-4.9-5.9-12-9-11.1-4.7-23-7-34.2-5.9-69-4.5-21.6 2.1-43 7.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m289.5 113.5q34.5 16.8 41.5 55 3.5 33.9-14 63-19.9 31-48.5 54.5-16.8 12.1-34 23.5-34.9-20.4-63-50-9.2-13.4-18.5-27-22-37.2-11.5-79 24.1-54.8 82-39.5 17.1 7.6 28 23 3.8 2.1 8 1 11.7-16.5 30-24.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m370.5 152.5q11.4 41.7-10.5 79-9 14.1-19.5 27-35.6 38.4-82 62.5-2.5 1-5 0-10.1-5-19-11.5 17.2-11.4 34-23.5 28.6-23.5 48.5-54.5 17.5-29.1 14-63-7-38.2-41.5-55 56.7-13.9 81 39z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m511.5 111.5q0 6.5 0 13-6.5 26-32 35-22.7 5-45 11.5-7.6 4.5-3.5 12.5 2.4 2.7 6 3 20.2-5.4 40.5-10-9.5 25.3-36 31-22.7 5-45 11.5-9.4 4.9-3.5 13.5 2.4 2 5.5 2 18.9-5 38-9-6.3 10-17 15.5-39.2 10.2-79 17.5 10.5-12.9 19.5-27 21.9-37.3 10.5-79 9.4-10.7 23-15.5 43.9-7.3 88-14 13.5-4 25-12 2.6-1 5 0.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m141.5 153.5q-10.5 41.8 11.5 79 9.3 13.6 18.5 27-40.1-8.6-80-18.5-10.7-5.5-17-15.5 18.8 4.4 37.5 9 9-1 8-10-1.8-3.7-5.5-5.5-22.5-5.9-45-11.5-26.5-5.7-36-31 20 5 40 10 11.2-2.4 6.5-13-1.4-1.8-3.5-2.5-22.5-6-45-11.5-25.5-9-32-35 0-6 0-12 3.4-1.3 7-0.5 10.5 7.5 23 11 44.1 6.7 88 14 14.3 4.9 24 16.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m31.5 159.5q22.5 5.5 45 11.5 2.1 0.7 3.5 2.5 4.7 10.6-6.5 13-20-5-40-10-2.4-8.3-2-17z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m479.5 159.5q0.4 8.7-2 17-20.3 4.6-40.5 10-3.6-0.3-6-3-4.1-8 3.5-12.5 22.3-6.5 45-11.5z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m69.5 207.5q22.5 5.6 45 11.5 3.7 1.8 5.5 5.5 1 9-8 10-18.7-4.6-37.5-9-5.3-8.1-5-18z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m441.5 207.5q0.3 9.9-5 18-19.1 4-38 9-3.1 0-5.5-2-5.9-8.6 3.5-13.5 22.3-6.5 45-11.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.096d9794b114118e3eb8eaf4f68b6e48.svg";
export { ForwardRef as ReactComponent };